import axios from 'axios'
import settings from '../../settings'

const Tv = {
  namespaced: true,
  state: () => ({
    packages: []
  }),
  mutations: {
    updatePackagesState(state, data) {
      state.packages = data;
    },

  },

  actions: {
    fetchPackages({ commit }, { page = 1, query = null }) {
      commit('updatePackagesState', [])
      axios.get(`${settings.apiUrl}/v2/tv/packages?page=${page}&q=${query}`).then(res => {
        commit('updatePackagesState', res.data.data)
      });
    },
    updatePackagesSequence({dispatch}, {data}) {
      const sec=new FormData();
      sec.append('data',JSON.stringify(data));
      axios.post(`${settings.apiUrl}/v2/tv/packages/sequence`, sec).then(res => {
        dispatch('fetchPackages',{
          page:1
        });
      });
    },
  },

  getters: {

  }
}

export default Tv;